// ── RecallCore Affiliate Reference Persistence ──
// Captures ?ref= from URL on any page, stores for 60 days (matches Affiliate Terms 7.1).
// Pricing checkout falls back to stored value if URL lacks ?ref=.

const STORAGE_KEY = 'rc_affiliate_ref';
const ATTRIBUTION_WINDOW_DAYS = 60;
const ATTRIBUTION_WINDOW_MS = ATTRIBUTION_WINDOW_DAYS * 24 * 60 * 60 * 1000;

export function captureRefFromUrl() {
  try {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (!ref) return;

    const cleanRef = String(ref).trim().slice(0, 64);
    if (!cleanRef || !/^[a-zA-Z0-9_-]+$/.test(cleanRef)) return;

    const payload = {
      ref: cleanRef,
      captured_at: Date.now(),
      expires_at: Date.now() + ATTRIBUTION_WINDOW_MS,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {
    // localStorage unavailable (private mode etc) — fail silently, URL ref still works
  }
}

export function getStoredRef() {
  try {
    if (typeof window === 'undefined') return null;
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.ref || !parsed?.expires_at) return null;
    if (Date.now() > parsed.expires_at) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed.ref;
  } catch (e) {
    return null;
  }
}

export function clearStoredRef() {
  try {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {}
}
